<template>
  <v-card>
    <v-form ref="addLineForm" @submit.prevent="submitAddLine()">
      <v-container style="padding-bottom: 0px">
        <v-layout row wrap>
          <dialog-header :title="'Add Line'" :details="`Batch (${batch.id})`"></dialog-header>
          <v-flex xs12>
            <div class="flex-container" bottom v-if="!!complianceIssues.length">
              <span class="red--text">
                <div v-for="(file,i) in masterFiles" :key="i">
                  <span
                    class="vertical-center-container"
                    v-if="!!complianceIssues.filter(item => item.masterFile == file.value).length"
                  >
                    <v-icon
                      class="pr-2"
                      :color="$store.state.global.pages[file.value]['color']"
                    >{{$store.state.global.pages[file.value]['icon']}}</v-icon>
                    {{ `${file.name}` }}
                    <span
                      v-for="(item,i) in complianceIssues.filter(item => item.masterFile == file.value)"
                      :key="i"
                      class="ml-1"
                    >{{ `${item.type}` }}: {{ makeShortDate(item.date) }}.</span>
                  </span>
                </div>
              </span>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Tip"
              color="primary"
              :items="filteredTips"
              @change="spoilId = null"
              v-model="tipId"
              item-text="name"
              item-value="id"
              :loading="loadingTips"
              :rules="tipRules"
              :prepend-icon="$store.state.global.pages.tip.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Spoil"
              color="primary"
              :items="filteredSpoils"
              v-model="spoilId"
              item-text="name"
              item-value="id"
              :loading="loadingSpoils"
              :rules="spoilRules"
              :prepend-icon="$store.state.global.pages.spoil.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="Sub-Contractor"
              color="primary"
              :items="contractors"
              v-model="contractorId"
              item-text="name"
              item-value="id"
              :loading="loadingContractors"
              :prepend-icon="$store.state.global.pages.contractor.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Driver"
              color="primary"
              :items="filteredDrivers"
              v-model="driverId"
              item-text="driverName_contractorName"
              item-value="id"
              :loading="loadingTips"
              :rules="driverRules"
              :prepend-icon="$store.state.global.pages.driver.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Vehicle"
              color="primary"
              :items="filteredVehicles"
              v-model="vehicleId"
              item-text="vehicleName_vehicleType_contractorName"
              item-value="id"
              :loading="loadingVehicles"
              :rules="vehicleRules"
              :prepend-icon="$store.state.global.pages.vehicle.icon"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <time-picker-wrapper v-model="startTime" label="* Start Time" color="primary"></time-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Notes"
              color="primary"
              v-model="notes"
              prepend-icon="note"
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
          <v-btn
            v-if="complianceIssues.length < 1"
            :color="primaryGreen"
            flat
            type="submit"
            :loading="loading"
          >Add</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'

// MIXINS
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getTips from '@/services/mixins/getMasterFiles/getTips'
import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import LineValidation from '../../validation/prelimAllocationValidation'
import FormatDates from '@/services/mixins/formatDates'
import FilterDriverVehicles from '@/services/mixins/filterDriverVehicles'
import FilterTipSpoils from '@/services/mixins/filterTipSpoils'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import TimePickerWrapper from '@/components/ui/timePickerWrapper'
import obj from './../../mixins/obj'

export default {
  mixins: [
    getContractors,
    getDrivers,
    getVehicles,
    getTips,
    getSpoils,
    LineValidation,
    FormatDates,
    FilterDriverVehicles,
    FilterTipSpoils,
    obj,
  ],
  components: {
    DialogHeader,
    TimePickerWrapper,
  },
  data() {
    return {
      tipId: null,
      spoilId: null,
      vehicleId: null,
      driverId: null,
      startTime: '',
      notes: null,
      contractorId: null,
      prefix: 'line',
      loading: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    resetForm() {
      this.contractorId = null
      this.tipId = null
      this.spoilId = null
      this.vehicleId = null
      this.driverId = null
      this.startTime = ''
      this.notes = null
    },
    submitAddLine() {
      if (!this.$refs.addLineForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.add()
    },
    add() {
      this.loading = true
      const line = {
        tipId: this.tipId,
        spoilId: this.spoilId,
        vehicleId: this.vehicleId,
        driverId: this.driverId,
        startTime: this.startTime,
        notes: this.notes,
      }
      AllocationService.createBatchLine(this.batch.id, line)
        .then((result) => {
          this.snack({ text: 'Line was added!', color: 'green' })
          this.close()
          this.loading = false
          this.resetForm()
          this.fetchBatches = true
        })
        .catch((err) => {
          this.loading = false
          this.snack({ text: err.response.data.message, color: 'red' })
        })
    },
  },
  computed: {
    fetchBatches: Store.getSet({
      store: 'allocationStaging',
      prop: 'fetchBatches',
    }),
    projectId() {
      return this.batch.site.project.id
    },
    complianceIssues() {
      var expiryDates = []
      var expired = []
      if (!!this.contractorObj) {
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.compensationInsuranceExpiry,
          type: 'Compensation Insurance',
        })
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.liabilityInsuranceExpiry,
          type: 'Liability Insurance',
        })
        expiryDates.push({
          masterFile: 'contractor',
          date: this.contractorObj.plantAndEquipInsuranceExpiry,
          type: 'Plant/Equipment Insurance',
        })
      }
      if (!!this.driverObj) {
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.licenceExpiry,
          type: 'Licence',
        })
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.vocExpiry,
          type: 'VOC',
        })
        expiryDates.push({
          masterFile: 'driver',
          date: this.driverObj.soaExpiry,
          type: 'Statement of Attainment',
        })
      }
      if (!!this.vehicleObj) {
        expiryDates.push({
          masterFile: 'vehicle',
          date: this.vehicleObj.registrationExpiry,
          type: 'Registration',
        })
        expiryDates.push({
          masterFile: 'vehicle',
          date: this.vehicleObj.pinkSlipExpiry,
          type: 'Pink Slip',
        })
      }
      if (!expiryDates.length) return expired

      for (var expiryDate of expiryDates) {
        if (!!expiryDate.date) {
          var expiryDateObj = new Date(expiryDate.date)
          var today = new Date()
          var daysToExpired = Math.ceil(
            (expiryDateObj - today) / 1000 / 60 / 60 / 24
          )
          if (daysToExpired < 1) expired.push(expiryDate)
        }
      }
      return expired
    },
  },
  props: {
    batch: Object,
  },
}
</script>